import React from 'react';
import { ConfirmDialog } from 'components/UI';
import Button from 'components/UI/V2/Button/Button';

interface ResumeEnrollmentDialogProps {
    open: boolean;
    processing?: boolean;
    onCancel: () => void;
    onResume: React.Dispatch<boolean>;
}

const ResumeEnrollmentDialog: React.FC<ResumeEnrollmentDialogProps> = ({ open, processing, onCancel, onResume }) => {
    return (
        <ConfirmDialog
            open={open}
            title="Resume Membership"
            question="Would you like to extend the End Date to compensate for the time this membership was paused?"
            onCancel={processing ? undefined : onCancel}
            actions={
                <>
                    <Button
                        variant="outlined"
                        size="medium"
                        label="No, keep original date"
                        disabled={processing}
                        onClick={event => {
                            event.stopPropagation();
                            onResume(false);
                        }}
                    />
                    <Button
                        variant="black"
                        size="medium"
                        label="Yes, add days"
                        disabled={processing}
                        isLoading={processing}
                        onClick={event => {
                            event.stopPropagation();
                            onResume(true);
                        }}
                    />
                </>
            }
        />
    );
};

export default ResumeEnrollmentDialog;
